var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-r"},[_c('div',{staticClass:"find-oppirtunity-view"},[(_vm.action === 'list')?_c('findOpportunity-edit'):_vm._e(),(_vm.action === 'publish')?_c('release-opportunity'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }